//codepen.io/davidmellul/embed/KeyLrw/?height=265&theme-id=0&default-tab=js,result&embed-version=2

import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.min.css";
import React from "react";
import { connect } from "react-redux";
import "./style.css";
class DropdownMenu extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			active: false,
		};

		this.togglemenu = this.togglemenu.bind(this);
		this.close = this.close.bind(this);
	}

	togglemenu() {
		this.setState((previous) => ({
			active: !previous.active,
		}));
		console.log("togglemenu this.state=", this.state);
	}

	close() {
		console.log("close clicked");
		this.setState({
			active: false,
		});

		console.log("togglemenu this.state=", this.state);
	}

	render() {
		const items = this.props.items;
		const active = this.state.active;

		return (
			<div className="dropdown-menu" tabIndex="0" onBlur={this.close}>
				<div
					className={`toggle ${active ? "active" : ""}`}
					onClick={this.togglemenu}
				>
					<span>
						<i className="fa fa-ellipsis-v" />
					</span>
				</div>
				<div className={`menu ${active ? "expanded" : "collapsed"}`}>
					<ul>
						{items.map((i, index) => (
							<li key={index} onClick={i.onClick}>
								<span>
									<i className={i.icon} />
								</span>
								<span className="label">{i.label}</span>
							</li>
						))}
					</ul>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps)(DropdownMenu);
